import { render, staticRenderFns } from "./taocs.vue?vue&type=template&id=212af8b7&scoped=true&"
import script from "./taocs.vue?vue&type=script&lang=js&"
export * from "./taocs.vue?vue&type=script&lang=js&"
import style0 from "./taocs.vue?vue&type=style&index=0&id=212af8b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212af8b7",
  null
  
)

export default component.exports